import { render, staticRenderFns } from "./lottery_page_win.vue?vue&type=template&id=4089b214&scoped=true"
import script from "./lottery_page_win.vue?vue&type=script&lang=ts"
export * from "./lottery_page_win.vue?vue&type=script&lang=ts"
import style0 from "./lottery_page_win.vue?vue&type=style&index=0&id=4089b214&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4089b214",
  null
  
)

export default component.exports